import { createSlice } from "@reduxjs/toolkit";
import { getAdsPlan } from "./thunk";

export interface IState {
  adsPlan: any;
  isAdsPlanLoading: boolean;
  isAdsPlanSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  adsPlan: null,
  isAdsPlanLoading: false,
  isAdsPlanSuccess: false,

  error: {},
};

const AdsPlanSlice = createSlice({
  name: "AdsPlan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get adsPlan
    builder.addCase(getAdsPlan.pending, (state: IState, action: any) => {
      state.isAdsPlanLoading = true;
    });
    builder.addCase(getAdsPlan.fulfilled, (state: IState, action: any) => {
      state.adsPlan = action.payload.data;
      state.isAdsPlanSuccess = true;
      state.isAdsPlanLoading = false;
    });
    builder.addCase(getAdsPlan.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAdsPlanSuccess = false;
      state.isAdsPlanLoading = false;
    });
  },
});

export const AdsPlanReducer = AdsPlanSlice.reducer;
